// src/components/hire/PaymentFlow/Upsell/UpsellOptionsList.jsx
import React from 'react'
import classNames from 'classnames'
// import { CircularSpinner } from '@/components/CircularSpinner'
import { UpsellOptionsSkeleton } from "../skeletons/UpsellOptionsSkeleton"
import { UpsellOptionCard } from './UpsellOptionCard'

export const UpsellOptionsList = ({
  options,
  selectedUpsell,
  onSelectUpsell,
  windowSize,
  isLoading
}) => {
  if (isLoading) {
    return <UpsellOptionsSkeleton windowSize={windowSize} />  
  }
  if (!options.length) {
    return null
  }
  return (
    <div className={classNames('grid gap-4', windowSize > 980 ? 'grid-cols-2' : 'grid-cols-1')}>
      {options.map(opt => (
        <UpsellOptionCard
          key={opt.id}
          option={opt}
          isSelected={selectedUpsell?.id === opt.id}
          onSelect={onSelectUpsell}
        />
      ))}
    </div>
  )
}
